import postWithToken from './base/post-with-token'

const customerUpdate = (id, data) => postWithToken(`/customer/${id}`)(data)

export default customerUpdate